import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=00a7c12a&scoped=true"
import script from "./Back.vue?vue&type=script&lang=js"
export * from "./Back.vue?vue&type=script&lang=js"
import style0 from "./Back.vue?vue&type=style&index=0&id=00a7c12a&prod&lang=css"
import style1 from "./Back.vue?vue&type=style&index=1&id=00a7c12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a7c12a",
  null
  
)

export default component.exports